import { render } from "./LbrxTermsAndConditions.vue?vue&type=template&id=25e57683&scoped=true"
import script from "./LbrxTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./LbrxTermsAndConditions.vue?vue&type=script&lang=js"

import "./LbrxTermsAndConditions.vue?vue&type=style&index=0&id=25e57683&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e57683"]])

export default __exports__